import {
  EDisplayName,
  EFieldsName,
  IDataPreference
} from "@/features/financas/views/Indicadores/@types/type";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import { IVendasPanelStrategy } from "../../Preferencias/strategy/preferenciasInterfaces";
import Preferencia from "../../Preferencias/strategy/Preferencia";

export default class VendasPanelStrategy implements IVendasPanelStrategy {
  createCompanies(companies: string[]): IDataPreference<string[] | string> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.empresas,
      fieldData: companies.join(","),
      displayName: EDisplayName.vendasPanel,
      id: EWidgets.VendasPanel
    });

    return preferencia.createPreferencesData();
  }

  createSourceData(
    sourceData: number | undefined
  ): IDataPreference<number | undefined> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.origemDosDados,
      fieldData: sourceData,
      displayName: EDisplayName.vendasPanel,
      id: EWidgets.VendasPanel
    });
    //if (preferencia.hasData(sourceData)) return undefined;

    return preferencia.createPreferencesData();
  }
}
